import styled from 'styled-components';

/*
 * The design's `.actionbar`, at dialog scale: a hairline, then the pair of
 * buttons at the trailing edge. The form used to end in one full-width Save
 * and no way out of the dialog other than the close cross.
 */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  margin-top: var(--s5);
  padding-top: var(--s4);
  border-top: 1px solid var(--line);
`;
